import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheckCircle,
  faHourglassHalf,
  faTimesCircle,
} from '@fortawesome/pro-solid-svg-icons'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { EnrolEvaluationState } from 'enum'
import styles from './EvaluationResults.module.scss'

interface IProps {
  evaluationState?: EnrolEvaluationState
}

const EvaluationResults: React.FC<IProps> = ({ evaluationState }) => {
  const tRelative = useTranslationRankmi({
    prefix: 'administration.monitor.evaluations',
  })

  const getStateInfo = () => {
    if (evaluationState === EnrolEvaluationState.Failed) {
      return {
        icon: faTimesCircle,
        text: 'failed',
        className: styles.iconFailed,
      }
    }

    if (evaluationState === EnrolEvaluationState.Approved) {
      return {
        icon: faCheckCircle,
        text: 'completed',
        className: styles.iconCompleted,
      }
    }

    return {
      icon: faHourglassHalf,
      text: 'inProgress',
      className: styles.iconInProgress,
    }
  }

  if (evaluationState == null) return <div className="mx-1">--</div>

  const { icon, text, className } = getStateInfo()

  return (
    <div className={`${styles.evaluationResultsContainer}`}>
      <div className={styles.state}>
        <FontAwesomeIcon className={`mr-1 ${className}`} icon={icon} />
        {tRelative(`states_v2.${text}`)}
      </div>
    </div>
  )
}

export default EvaluationResults
